export const environment = {
  production: true,
  apiUrl: "https://siaiap44.univali.br/api/v1",
  apiGxUrl: "https://fiaiweb04.univali.br/Portal3",
  //apiGxUrl: "https://siaiweb21.univali.br/Portal3",
  apiGxUrlToken: "https://fiaiweb04.univali.br/Portal3",
  //apiGxUrlToken: "https://siaiweb21.univali.br/Portal3",
  urlDpParametros: "https://fiaiweb04.univali.br/Portal3/dpparametros.svc/rest",
  //urlDpParametros: "https://siaiweb21.univali.br/Portal3/dpparametros.svc/rest",

  paramCodMatriculaOnline: "/?paramcod=31&ParCharCod=23",
  paramCodArquivoTamanhoLimite: "/?paramcod=155&ParNumCod=7",
  paramCodArquivoExtensoesAceitas: "/?paramcod=225&ParCharCod=7",
  paramCodMensagemErroArquivoTamanho: "/?paramcod=155&ParClobCod=2",
  paramCodMensagemErroArquivoExtensao: "/?paramcod=155&ParClobCod=3",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts